export const AUTH_NOTIFICATION_MESSAGES = {
    NO_DATA_PROVIDER_ASSIGNED:
        'No data provider has been assigned to your account. You are being logged out. Please contact your administrator.',
};

export const AUTH_NOTIFICATION_DELAYS = {
    LOGOUT_AFTER_WARNING_MS: 6000,
};